import { stringList } from "aws-sdk/clients/datapipeline";

export const getAuthToken = () => {
  return localStorage.getItem("token");
};

export interface User {
  uid: string;
  email: string;
  fullName: string;
  profilePic: string | null;
  isBlocked: boolean;
  subscriptionExpireAt: null | number;
}

export interface Category {
  pcid: string;
  title: string;
  description: string | null;
  image: string | null;
  icon: string | null;
  defaultPosition: number;
  isPinned: boolean;
  pinnedAt: number | null;
}

export interface Prayer {
  pmid: string;
  title: string;
  description: string;
  iconImage: string | null;
  audioUrl: string | null;
  audioDuration: string | null;
  prayerCategories: [] | Category[];
}

export interface DashboardResponse {
  data: {
    totalUsers: number;
    registeredThisMonthUsers: number;
    todayUsers: number;
    usersGraphData: [
      {
        date: string;
        value: number;
        total: number;
      },
    ];
  };
}
export interface Tag {
  tid: string;
  title: string;
}

export interface Review {
  ruid: string;
  rating: number;
  comment: string;
  user: {
    uid: string;
    email: string;
    fullName: string;
    profilePic: string | null;
    isBlocked: boolean;
    subscriptionExpireAt: null | number;
  };
  createdAt: number;
}

export interface Meta {
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}
